/* eslint-disable padding-line-between-statements */
import _ from 'lodash';


// US26348
function PrintDocumentUtils (submissionVM) {

    function getQuoteID(){
        const jobType = _.get(submissionVM, 'baseData.jobType.value')?.code;
        let quoteID
    
        if(jobType === 'Renewal' || jobType === 'PolicyChange') {
            quoteID = _.get(submissionVM, 'jobID')?.value
        } else {
            quoteID = _.get(submissionVM, 'quoteID')?.value
        }
        return quoteID;
    }

    function getQuoteStatus(){
        if (submissionVM.quoteData.offeredQuotes.length > 1) {
            return submissionVM.quoteData.value.offeredQuotes[1].status;   
        }
        return submissionVM.quoteData.value.offeredQuotes[0].status;
    }

    function getPublicID(){
        if (submissionVM.quoteData.offeredQuotes.length > 1) {
           return  submissionVM.quoteData.value.offeredQuotes[1].publicID;
        } 
        return submissionVM.quoteData.value.offeredQuotes[0].publicID;
    }
    
    function getPath(){
        let path
        const jobType = _.get(submissionVM, 'baseData.jobType.value')?.code;
        if(jobType === 'Renewal') {
            path = `${process.env.PUBLIC_PATH}/renewal/${getQuoteID()}/documents`
        } else if(jobType === 'PolicyChange') {
            path = `${process.env.PUBLIC_PATH}/change/${getQuoteID()}/documents`
        } else {
            path = `${process.env.PUBLIC_PATH}/quotes/${getQuoteID()}/documents`
        }
        return path
    }

    return {
        getQuoteID,
        getQuoteStatus,
        getPublicID, 
        getPath
    }
}

export default PrintDocumentUtils